// document.addEventListener('DOMContentLoaded', function () {
//   const galleries = document.querySelectorAll('media-gallery');

//   galleries.forEach(function (gallery) {
//     const mainElement = gallery.querySelector('.swiper-product-main');
//     const thumbsElement = gallery.querySelector('.swiper-product-thumbnails');

//     if (!mainElement) return;

//     let thumbsSwiper = null;

//     /*
//      * Thumbnail Swiper
//      */
//     if (thumbsElement) {
//       thumbsSwiper = new Swiper(thumbsElement, {
//         slidesPerView: 4,
//         spaceBetween: 10,
//         // watchSlidesProgress: true,
//         direction: 'vertical',
//         mousewheel: true,
//         navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//         breakpoints: {
//           0: {
//             slidesPerView: 3
//           },
//           750: {
//             slidesPerView: 4
//           },
//           990: {
//             slidesPerView: 5
//           }
//         }
//       });
//     }

//     /*
//      * Main Product Swiper
//      */
//     const mainSwiper = new Swiper(mainElement, {
//       slidesPerView: 1,
//       spaceBetween: 0,

//       speed: 400,

//       navigation: {
//         nextEl: gallery.querySelector('.product-gallery-next'),
//         prevEl: gallery.querySelector('.product-gallery-prev')
//       },

//       thumbs: thumbsSwiper
//         ? {
//             swiper: thumbsSwiper
//           }
//         : undefined
//     });

//     /*
//      * Update thumbnail active state
//      */
//     if (thumbsElement) {
//       const thumbnails = thumbsElement.querySelectorAll('.thumbnail-list__item');

//       mainSwiper.on('slideChange', function () {
//         thumbnails.forEach(function (thumbnail) {
//           thumbnail.querySelector('button')?.removeAttribute('aria-current');
//         });

//         const activeThumbnail = thumbnails[mainSwiper.activeIndex];

//         if (activeThumbnail) {
//           activeThumbnail
//             .querySelector('button')
//             ?.setAttribute('aria-current', 'true');
//         }
//       });
//     }
//   });
// });





// old_js ===========================================================================================================================================


// document.addEventListener('DOMContentLoaded', function () {
//   const galleries = document.querySelectorAll('media-gallery');

//   galleries.forEach(function (gallery) {
//     const mainElement = gallery.querySelector('.swiper-product-main');

//     if (!mainElement) return;

    
//     const mainSwiper = new Swiper(mainElement, {
//       slidesPerView: 1,
//       spaceBetween: 0,
//       speed: 400,

//       navigation: {
//         nextEl: gallery.querySelector('.product-gallery-next'),
//         prevEl: gallery.querySelector('.product-gallery-prev'),
//       },
//     });
    

    
//     const thumbnailSlider = gallery.querySelector('thumbnail-slider');

//     if (!thumbnailSlider) return;

//     const thumbnails = thumbnailSlider.querySelectorAll(
//       '.thumbnail-list__item'
//     );

    
//     function getMainSlideIndex(target) {
//       const slides = mainElement.querySelectorAll('.swiper-slide');

//       for (let i = 0; i < slides.length; i++) {
//         if (slides[i].dataset.mediaId === target) {
//           return i;
//         }
//       }

//       return -1;
//     }

    


//     function setActiveThumbnail(target) {
//   if (!target) return;

//   let found = false;

//   thumbnails.forEach(function (thumbnail) {
//     const button = thumbnail.querySelector('.thumbnail');

//     thumbnail.classList.remove('is-active');

//     if (button) {
//       button.removeAttribute('aria-current');
//     }

//     if (thumbnail.dataset.target === target) {
//       thumbnail.classList.add('is-active');

//       if (button) {
//         button.setAttribute('aria-current', 'true');
//       }

//       found = true;
//     }
//   });

  
// }

    
//     thumbnails.forEach(function (thumbnail) {
//       const button = thumbnail.querySelector('.thumbnail');

//       if (!button) return;

//       button.addEventListener('click', function (event) {
//         event.preventDefault();

//         const target = thumbnail.dataset.target;

//         if (!target) return;

//         const slideIndex = getMainSlideIndex(target);

//         if (slideIndex === -1) return;

//         mainSwiper.slideTo(slideIndex);

//         setActiveThumbnail(target);
//       });
//     });

    


//     mainSwiper.on('slideChange', function () {
//   const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];

//   if (!activeSlide) return;

//   const target = activeSlide.dataset.mediaId;

  

//   if (!target) return;

//   setActiveThumbnail(target);
// });

    

//     const initialSlide = mainSwiper.slides[mainSwiper.activeIndex];

//     if (initialSlide) {
//       setActiveThumbnail(initialSlide.dataset.mediaId);
//     }
//   });
// });






// new_js  ================================================================================================================================================




function initProductGallery(gallery) {
  if (!gallery) return;

  /*
   * Prevent duplicate Swiper initialization
   */
  if (gallery.dataset.swiperInitialized === 'true') {
    return;
  }

  /*
   * MAIN SWIPER
   */
  const mainElement = gallery.querySelector('.swiper-product-main');

  if (!mainElement) {
    return;
  }

  const mainSwiper = new Swiper(mainElement, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 400,

    navigation: {
      nextEl: gallery.querySelector('.product-gallery-next'),
      prevEl: gallery.querySelector('.product-gallery-prev'),
    },
  });

  /*
   * Mark gallery as initialized
   */
  gallery.dataset.swiperInitialized = 'true';


  /*
   * DAWN THUMBNAILS
   */
  const thumbnailSlider = gallery.querySelector('thumbnail-slider');

  if (!thumbnailSlider) {
    return;
  }

  const thumbnails = thumbnailSlider.querySelectorAll(
    '.thumbnail-list__item'
  );


  /*
   * FIND MAIN SLIDE INDEX
   *
   * Thumbnail:
   * data-target="..."
   *
   * Main slide:
   * data-media-id="..."
   */
  function getMainSlideIndex(target) {
    const slides = mainElement.querySelectorAll('.swiper-slide');

    for (let i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === target) {
        return i;
      }
    }

    return -1;
  }


  /*
   * SET ACTIVE THUMBNAIL
   */
  function setActiveThumbnail(target) {
    if (!target) return;

    thumbnails.forEach(function (thumbnail) {
      const button = thumbnail.querySelector('.thumbnail');

      thumbnail.classList.remove('is-active');

      if (button) {
        button.removeAttribute('aria-current');
      }

      if (thumbnail.dataset.target === target) {
        thumbnail.classList.add('is-active');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }
      }
    });
  }


  /*
   * THUMBNAIL CLICK
   *
   * Thumbnail → Main Swiper
   */
  thumbnails.forEach(function (thumbnail) {
    const button = thumbnail.querySelector('.thumbnail');

    if (!button) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();

      const target = thumbnail.dataset.target;

      if (!target) return;

      const slideIndex = getMainSlideIndex(target);

      if (slideIndex === -1) {
        return;
      }

      mainSwiper.slideTo(slideIndex);

      setActiveThumbnail(target);
    });
  });


  /*
   * MAIN SWIPER CHANGE
   *
   * Main Swiper → Active Thumbnail
   */
  mainSwiper.on('slideChange', function () {
    const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];

    if (!activeSlide) return;

    const target = activeSlide.dataset.mediaId;

    if (!target) return;

    setActiveThumbnail(target);
  });


  /*
   * INITIAL ACTIVE THUMBNAIL
   */
  const initialSlide = mainSwiper.slides[mainSwiper.activeIndex];

  if (initialSlide) {
    setActiveThumbnail(initialSlide.dataset.mediaId);
  }
}


/*
 * NORMAL PRODUCT PAGE
 *
 * This runs when the page initially loads.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    initProductGallery(gallery);
  });
});
